import type { adminViews } from '@cwos/api-client';

/**
 * Pure derivations for the session detail / scheduled-vs-actual surface
 * (doc 01 A2.3/A2.5). DOM-free and unit-tested.
 */

/** Scheduled-vs-actual variance in plain words. Null actual → not yet clocked. */
export function varianceLabel(cmp: adminViews.ScheduledComparison): string {
  if (cmp.actualMinutes === null || cmp.varianceMinutes === null) {
    return 'no time record yet';
  }
  const v = cmp.varianceMinutes;
  if (v === 0) return 'on time';
  const mag = Math.abs(v);
  return v > 0 ? `${mag} min over` : `${mag} min under`;
}

/** Breadcrumb coverage as a whole-number percent, or null when unknown. */
export function coveragePct(ratio: number | null): number | null {
  if (ratio === null) return null;
  return Math.round(ratio * 100);
}

/** Non-superseded punches, in occurred order — what the chain renders. */
export function livePunches(detail: adminViews.SessionDetail): adminViews.SessionPunchEntry[] {
  return [...detail.punches]
    .filter((p) => !p.superseded)
    .sort((a, b) => new Date(a.occurredAt).getTime() - new Date(b.occurredAt).getTime());
}

/** Session-level severity for the header pill (worst open exception wins). */
export function sessionSeverity(detail: adminViews.SessionDetail): 'urgent' | 'look' | 'good' {
  const open = detail.exceptions.filter((e) => e.status !== 'resolved');
  if (open.some((e) => e.severity === 'critical' || e.severity === 'warning')) {
    return open.some((e) => e.severity === 'critical') ? 'urgent' : 'look';
  }
  return 'good';
}
